import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SchoolService } from '../../core/school.service';
import { SeafarerAdminService } from '../../core/seafarer-admin.service';
import { ActivatedRoute } from '@angular/router';
import { SchoolAppStudentStatusBaseComponent } from '../school-app-student-status-base/school-app-student-status-base.component';

@Component({
  selector: 'app-school-app-student-on-board',
  templateUrl: './school-app-student-on-board.component.html',
  styleUrls: ['./school-app-student-on-board.component.css']
})
export class SchoolAppStudentOnBoardComponent extends SchoolAppStudentStatusBaseComponent implements OnInit {
  status = 'onboard';

  constructor(
    route: ActivatedRoute,
    cookieService: CookieService,
    schoolService: SchoolService,
    seafarerAdminService: SeafarerAdminService
  ) {
    super(route, cookieService, schoolService, seafarerAdminService);
  }
}
